export default "__VITE_ASSET__C23bCXgX__"